// const params = new URLSearchParams(window.location.search);setUserId(params.get('userId'));

import { useState } from 'react';
import Modal from '../shared/ModalPortal/Modal';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setToastData } from '../../app/toastReducer';
import ToastNotification from '../Reusable/ToastNotification';
import { useTranslation } from 'react-i18next';
import FeatureDetails from './FeatureDetails';
import { ActionButtons } from '../PermissionSet/NewPermissionSet';

const FeatureDetailModal = ({ setNewDataLoaded, openModal, setOpenModal }: any) => {
  const dispatch = useAppDispatch();
  const toastData = useAppSelector((state) => state.toast);
  const { t } = useTranslation();

  return (
    <>
      <ToastNotification
        message={toastData.toastMessage}
        isActive={toastData.isToastActive}
        setIsActive={() =>
          dispatch(
            setToastData({
              toastMessage: '',
              isToastActive: false,
              toastType: null
            })
          )
        }
        status={toastData.toastType}
      />

      <Modal
        showHeader={true}
        showCloseIcon={true}
        width="85rem"
        headerText={t('T_NEW_FEATURE')}
        toggleVisiblity={(value: boolean) => {
          setOpenModal(false);
        }}
        isVisible={openModal}
        body={
          <div>
            <FeatureDetails
              setNewDataLoaded={setNewDataLoaded}
              hideModal={(value: boolean) => {
                setOpenModal(false);
              }}
            ></FeatureDetails>
          </div>
        }
      />
    </>
  );
};

export default FeatureDetailModal;
